import { Routes } from '@angular/router';
import { BlogTagComponent } from './components/blog-tags/blog-tags.component';
import { HomeComponent } from './components/home/home.component';
import { HotelSearchComponent } from './components/hotel-search/hotel-search.component';
import { WellnessPageComponent } from './components/wellness-page/wellness-page.component';
import { HotelRouteDecisionComponent } from './shared/components/hotel-route-decision/hotel-route-decision.component';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { HotelRouteDecisionResolver } from './shared/resolvers/hotel-route.resolver';
import { DiningRouteDecisionResolver } from './shared/resolvers/dining-routes.resolver';
import { DiningRouteDecisionComponent } from './shared/components/dining-route-decision/dining-route-decision.component';
import { HotelGalleryComponent } from './shared/components/hotel-description/hotel-gallery';

export const routes: Routes = [
  {
    path: 'blog',
    loadChildren: () => import('./components/blog/blog.routes').then(m => m.blogRoutes),
  },
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'hotels',
    component: HotelSearchComponent,
  },
  {
    path: 'our-hotels',
    component: HotelSearchComponent,
  },
  {
    path: 'restaurant/:slug',
    resolve: { decision: DiningRouteDecisionResolver },
    component: DiningRouteDecisionComponent,
  },
  {
    path: 'kera-spa-udaan-hotels-resorts',
    component: WellnessPageComponent,
  },
  {
    path: 'tags/:slug',
    component: BlogTagComponent,
  },

  // ✅ NEW: Hotel detail with destination prefix
  // e.g. /our-hotels/darjeeling/udaan-nirvana-resort-best-resort-in-mall-road-darjeeing
  // MUST be declared BEFORE the single-segment route so Angular matches the
  // more-specific two-segment pattern first.
  // When BOTH :destination and :slug params exist, the resolver skips the
  // ambiguity check and goes straight to hotel lookup.
  {
    path: 'our-hotels/:destination/:slug',
    resolve: { decision: HotelRouteDecisionResolver },
    component: HotelRouteDecisionComponent,
  },

  // ✅ UNCHANGED: single :slug handles BOTH destination listing pages
  // (e.g. /our-hotels/darjeeling) AND legacy hotel detail URLs.
  // The resolver decides which case it is.
  //
  // ⚠️  DO NOT add a separate `our-hotels/:destination` route pointing
  //     directly to HotelSearchComponent — that bypasses the resolver and
  //     causes all destination clicks to load the generic "all hotels" view.
  {
    path: 'our-hotels/:slug',
    resolve: { decision: HotelRouteDecisionResolver },
    component: HotelRouteDecisionComponent,
  },

  // ✅ Gallery routes — two-segment before single-segment
  {
    path: 'our-hotels/:destination/:slug/gallery',
    loadComponent: () =>
      import('./shared/components/hotel-description/hotel-gallery/hotel-gallery-page.component')
        .then(m => m.HotelGalleryPageComponent),
  },
  {
    path: 'our-hotels/:slug/gallery',
    loadComponent: () =>
      import('./shared/components/hotel-description/hotel-gallery/hotel-gallery-page.component')
        .then(m => m.HotelGalleryPageComponent),
  },

  {
    path: 'offers',
    loadComponent: () =>
      import('./components/offers/offers.component').then(
        (m) => m.OffersComponent
      ),
  },

  // ✅ Availability routes — two-segment before single-segment
  {
    path: 'our-hotels/:destination/:slug/availability',
    loadComponent: () =>
      import('./components/booking/booking-step-1/booking-step-one.component')
        .then(m => m.BookingStepOneComponent)
  },
  {
    path: 'our-hotels/:slug/availability',
    loadComponent: () =>
      import('./components/booking/booking-step-1/booking-step-one.component')
        .then(m => m.BookingStepOneComponent)
  },

  {
    path: 'booking',
    loadChildren: () =>
      import('./components/booking/booking-routes').then(m => m.bookingRoutes)
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./components/contact-us/contact-us.component').then(
        (m) => m.ContactUsComponent
      ),
  },
  {
    path: 'faqs',
    loadComponent: () =>
      import('./components/faqs/faqs.component').then((m) => m.FaqsComponent),
  },
  {
    path: 'careers',
    loadComponent: () =>
      import('./components/careers/careers.component').then(
        (m) => m.CareersComponent
      ),
  },
  {
    path: 'careers/:id',
    loadComponent: () =>
      import('./components/job-detail/job-detail.component').then(
        (m) => m.JobDetailComponent
      ),
  },
  {
    path: 'terms-and-condition',
    loadComponent: () =>
      import(
        './components/terms-and-condition/terms-and-condition.component'
      ).then((m) => m.TermsAndConditionComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./components/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'testimonials',
    loadComponent: () =>
      import('./components/testimonials/testimonials.component').then(
        (m) => m.TestimonialsComponent
      ),
  },
  {
    path: 'traveller-stories',
    loadComponent: () =>
      import('./components/traveller-stories/traveller-stories.component').then(
        (m) => m.TravellerStoriesPageComponent
      ),
  },
  {
    path: 'lead-form',
    loadComponent: () =>
      import('./components/lead-form/lead-form.component').then(
        (m) => m.LeadFormComponent
      ),
  },
  {
    path: 'media',
    loadComponent: () =>
      import('./components/media/media.component').then(
        (m) => m.MediaComponent
      ),
  },

  { path: '404', component: PageNotFoundComponent },

  // {
  //   path: '**',
  //   redirectTo: '404',
  // },
];
